class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addButton = this.querySelector('.cart-upsell__add-button');
    if (this.addButton) {
      this.addButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }

  addToCart() {
    const variantId = this.dataset.variantId;
    if (!variantId) return;

    this.addButton.disabled = true;

    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1,
        'properties': {
          "_upsell_item": "true"
        }
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(cart => {
      if (cart.status === 422) {
        console.error(cart.description);
        this.addButton.disabled = false;
        return;
      }
      
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: cart });
      }

      this.style.display = 'none';
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.open();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      this.addButton.disabled = false;
    });
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }

  renderContents(cart) {
    this.getSectionsToRender().forEach((section => {
      if(cart.sections[section.id]){
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(cart.sections[section.id], section.selector);
      }
    }));
    
    // After re-rendering, re-initialize any components if needed
    setTimeout(() => {
        const newUpsell = document.querySelector('cart-upsell');
        if (newUpsell && typeof newUpsell.init === 'function') {
            newUpsell.init();
        }
        document.querySelector('cart-drawer').open();
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('cart-upsell', CartUpsell);
